import ToastEvents from './ToastEvents';

const SuccessToast = (text: string) => {
  ToastEvents.show({
    title: 'Success!',
    text,
    type: 'success'
  });
};

export default SuccessToast;
